/*
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-05-14 19:21:53
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-05-14 21:49:28
 * @FilePath: /goldenSalesMobile/src/api/refund.js
 * @Description: 退款相关api
 */
import { requestOfPut, requestOfGet } from "../utils/http";
const baseUrl = 'wechath5/zh-cn/v1/refund';

// 提交退单
export function submitRefund(params) {
  return requestOfPut(baseUrl, params)
}

// 退单管理列表
export function getRefundOrderList(params) {
  return requestOfGet(baseUrl, params)
}

// 退单详情
export function getRefundOrderDetail(params) {
  return requestOfGet(baseUrl, params)
}
